import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

require('highcharts/modules/exporting')(Highcharts);

interface IBarChartComponentProps {
  title: string
  categories: string[]
  dataPoints: any[]
  noDataMessage?: string
  click?: any
  htmlSubtitle?: string
  name: string
  chartHeight?: number
  suffix?: string
  tooltipFormatterFunction: any
}

interface IBarChartComponentState {
  trendChartRef: any
  trendGraphOptions: any
}

export class BarChartComponent extends React.Component<IBarChartComponentProps> {
  state: IBarChartComponentState = {
    trendChartRef: undefined,
    trendGraphOptions: undefined
  }
  componentDidMount() {
    this.state.trendChartRef = React.createRef();
    if (this.props.dataPoints.length > 0) {
      this.setTrendGraphOptions();
    }
  }

  componentDidUpdate(prevProps: IBarChartComponentProps, prevState: IBarChartComponentState) {

    if (prevProps.dataPoints !== this.props.dataPoints) {
      this.setTrendGraphOptions();
    }
  }

  setTrendGraphOptions() {
    const { categories, click, dataPoints, noDataMessage, title, htmlSubtitle, name, chartHeight, suffix, tooltipFormatterFunction } = this.props;
    const callback = click;

    let h = 200;
    if (chartHeight) {
      h = chartHeight
    }
    const selectedSuffix = suffix ? suffix : '';
    const titleOptions = {
      style: {
        display: title.length ? 'block' : 'none',
      },
      useHTML: true,
      text: title,
      x: 0,
      y: 5,
      align: 'left'
    }
    let subtitle = {};
    if (htmlSubtitle) {
      subtitle = {
        useHTML: true,
        text: htmlSubtitle
      };
    }

    this.setState({
      trendGraphOptions: {
        lang: {
          noData: noDataMessage
        },
        chart: {
          type: 'bar',
          height: h,
        },
        title: titleOptions,
        subtitle,
        xAxis: {
          categories
        },
        yAxis: {
          title: {
            text: null
          }
        },
        tooltip: {
          formatter: tooltipFormatterFunction,
          followPointer: true,
          followTouchMove: true,
          backgroundColor: '#FFF',
          // positioner: function (labelWidth, labelHeight, point) {
          //     var tooltipX = point.plotX;
          //     var tooltipY = point.plotY - (labelHeight / 3);
          //     return {
          //         x: tooltipX,
          //         y: tooltipY
          //     };
          // }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            marker: {
              states: {
                select: {
                  fillColor: '#E24585',
                  lineColor: '#E24585',
                  lineWidth: 0
                }
              }
            },
            dataLabels: {
              enabled: true,
              style: {
                color: 'black',
                fontSize: '12px',
                textShadow: false,
              },
              format: '{y}' + selectedSuffix,
              allowOverlap: true,
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          name,
          data: dataPoints,
          // fixme
          point: {
            events: {
              click(event) {
                if (callback) {
                  const obj = event.point;
                  callback(obj);
                }
              }
            }
          }
        }],
        exporting: {
          chartOptions: {
            title: {
              style: {
                display: 'block'
              }
            },
            plotOptions: {
              series: {
                dataLabels: {
                  enabled: true
                }
              }
            }
          },
          buttons: {
            contextButton: {
              symbol: 'url(images/bars.png)',
            }
          },
          sourceHeight: 1900 / 2.5,
          sourceWidth: 1080 / 2.5,
        },

        navigation: {
          buttonOptions: {
            verticalAlign: 'top',
            y: -10
          }
        }
      }
    })
  }

  render() {
    const { trendChartRef, trendGraphOptions } = this.state;
    return (
      <div>
        <section className="highcharts-component">
          {
            (trendGraphOptions && trendChartRef) &&
            <HighchartsReact
              highcharts={Highcharts}
              options={trendGraphOptions}
              allowChartUpdate={true}
              ref={trendChartRef}
              immutable={true}
            />
          }
        </section>
      </div>
    );
  }
}
